/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../glyph/glyph_icon';
import '../../../common/currency_codes';
import '../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "component": {
                "nested": {
                  "ButtonDescription": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "style": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription.ButtonStyle",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "BUTTON_STYLE_DEFERRED"
                        }
                      },
                      "variant": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription.ButtonVariant",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "BUTTON_VARIANT_DEFERRED"
                        }
                      },
                      "icon": {
                        "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ButtonStyle": {
                        "values": {
                          "BUTTON_STYLE_DEFERRED": 0,
                          "BUTTON_STYLE_PRIMARY": 1,
                          "BUTTON_STYLE_SECONDARY": 2,
                          "BUTTON_STYLE_TERTIARY": 3
                        }
                      },
                      "ButtonVariant": {
                        "values": {
                          "BUTTON_VARIANT_DEFERRED": 0,
                          "BUTTON_VARIANT_NORMAL": 1,
                          "BUTTON_VARIANT_DESTRUCTIVE": 2
                        }
                      }
                    }
                  },
                  "InputHintDescription": {
                    "fields": {
                      "helper": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "error": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "InputFieldAccessoryDescription": {
                    "fields": {
                      "tooltip": {
                        "type": "squareup.bbfrontend.common.component.InputFieldAccessoryDescription.Tooltip",
                        "id": 1
                      }
                    },
                    "nested": {
                      "Tooltip": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "accessory": {
                        "oneof": ["tooltip"]
                      }
                    }
                  },
                  "TextInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "placeholder": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": "squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 3,
                        "rule": "optional"
                      },
                      "leadingAccessory": {
                        "type": "squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 4,
                        "rule": "optional"
                      },
                      "trailingAccessory": {
                        "type": "squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 5,
                        "rule": "optional"
                      },
                      "formatter": {
                        "type": "squareup.bbfrontend.common.component.TextInputDescription.Formatter",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": "FORMATTER_DEFERRED"
                        }
                      }
                    },
                    "nested": {
                      "Formatter": {
                        "values": {
                          "FORMATTER_DEFERRED": 0,
                          "FORMATTER_SSN": 1
                        }
                      }
                    }
                  },
                  "MoneyInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "currencyCode": {
                        "type": "squareup.common.CurrencyCode",
                        "id": 2,
                        "rule": "optional"
                      },
                      "placeholder": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "minimum": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "maximum": {
                        "type": "squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": "squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 6,
                        "rule": "optional"
                      },
                      "leadingAccessory": {
                        "type": "squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 7,
                        "rule": "optional"
                      },
                      "trailingAccessory": {
                        "type": "squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  },
                  "BannerDescription": {
                    "fields": {
                      "variant": {
                        "type": "squareup.bbfrontend.common.component.BannerDescription.BannerVariant",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "BANNER_VARIANT_DEFERRED"
                        }
                      },
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "text": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "BannerVariant": {
                        "values": {
                          "BANNER_VARIANT_DEFERRED": 0,
                          "BANNER_VARIANT_INFO": 1,
                          "BANNER_VARIANT_SUCCESS": 2,
                          "BANNER_VARIANT_WARNING": 3,
                          "BANNER_VARIANT_CRITICAL": 4,
                          "BANNER_VARIANT_INSIGHT": 5
                        }
                      }
                    }
                  },
                  "PillDescription": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "icon": {
                        "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 2,
                        "rule": "optional"
                      },
                      "variant": {
                        "type": "squareup.bbfrontend.common.component.PillDescription.PillVariant",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "PILL_VARIANT_DEFERRED"
                        }
                      },
                      "size": {
                        "type": "squareup.bbfrontend.common.component.PillDescription.PillSize",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "PILL_SIZE_DEFERRED"
                        }
                      }
                    },
                    "nested": {
                      "PillVariant": {
                        "values": {
                          "PILL_VARIANT_DEFERRED": 0,
                          "PILL_VARIANT_NORMAL": 1,
                          "PILL_VARIANT_EMPHASIS": 2,
                          "PILL_VARIANT_SUCCESS": 3,
                          "PILL_VARIANT_WARNING": 4,
                          "PILL_VARIANT_CRITICAL": 5,
                          "PILL_VARIANT_INSIGHT": 6,
                          "PILL_VARIANT_ALPHA": 7,
                          "PILL_VARIANT_BETA": 8
                        }
                      },
                      "PillSize": {
                        "values": {
                          "PILL_SIZE_DEFERRED": 0,
                          "PILL_SIZE_NORMAL": 1,
                          "PILL_SIZE_COMPACT": 2
                        }
                      }
                    }
                  },
                  "WebURL": {
                    "fields": {
                      "urlString": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "useSessionBridge": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "DateInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": "squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AddressInputDescription": {
                    "fields": {
                      "isEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "isCountrySelectionEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "errorFields": {
                        "type": "squareup.bbfrontend.common.component.AddressInputDescription.ErrorFieldType",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ErrorFieldType": {
                        "values": {
                          "ADDRESS_LINE_1": 0,
                          "ADDRESS_LINE_2": 1,
                          "LOCALITY": 2,
                          "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                          "POSTAL_CODE": 4
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription?.nested?.ButtonStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription?.nested?.ButtonVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InputHintDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InputFieldAccessoryDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InputFieldAccessoryDescription?.nested?.Tooltip && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextInputDescription?.nested?.Formatter && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.MoneyInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.BannerDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.BannerDescription?.nested?.BannerVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.PillDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.PillDescription?.nested?.PillVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.PillDescription?.nested?.PillSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.WebURL && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.DateInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.AddressInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.AddressInputDescription?.nested?.ErrorFieldType) {
  $root.addJSON(jsonData);
}

/**
 * Configuration for a button component.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=126724%3A293438&t=F7FEEyRf4ee89URW-1">Market - Button</a>
 *
 * SOURCE ButtonDescription @ squareup/bbfrontend/common/component/component.proto at 18:1
 */
export const ButtonDescription = $root.lookupType('squareup.bbfrontend.common.component.ButtonDescription');
fixType(ButtonDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ButtonDescription);
/**
 * SOURCE ButtonStyle @ squareup/bbfrontend/common/component/component.proto at 24:3
 */
ButtonDescription.ButtonStyle = $root.lookupEnum('squareup.bbfrontend.common.component.ButtonDescription.ButtonStyle').values;
/**
 * SOURCE ButtonVariant @ squareup/bbfrontend/common/component/component.proto at 34:3
 */
ButtonDescription.ButtonVariant = $root.lookupEnum('squareup.bbfrontend.common.component.ButtonDescription.ButtonVariant').values;
/**
 * Configuration for hints below an input. This can be helper and/or error text.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=31507%3A1054&t=F7FEEyRf4ee89URW-1">Market - Helper</a>
 *
 * SOURCE InputHintDescription @ squareup/bbfrontend/common/component/component.proto at 66:1
 */
export const InputHintDescription = $root.lookupType('squareup.bbfrontend.common.component.InputHintDescription');
fixType(InputHintDescription);
Builder.createAndAttachToType(InputHintDescription);
/**
 * Configuration for input accessories.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0%C2%AE?type=design&node-id=126724-293625&mode=design&t=nMORvDUZLiUVgxVF-0">Market - Input</a>
 *
 * SOURCE InputFieldAccessoryDescription @ squareup/bbfrontend/common/component/component.proto at 75:1
 */
export const InputFieldAccessoryDescription = $root.lookupType('squareup.bbfrontend.common.component.InputFieldAccessoryDescription');
fixType(InputFieldAccessoryDescription);
Builder.createAndAttachToType(InputFieldAccessoryDescription);
/**
 * SOURCE Tooltip @ squareup/bbfrontend/common/component/component.proto at 80:3
 */
InputFieldAccessoryDescription.Tooltip = $root.lookupType('squareup.bbfrontend.common.component.InputFieldAccessoryDescription.Tooltip');
fixType(InputFieldAccessoryDescription.Tooltip);
Builder.createAndAttachToType(InputFieldAccessoryDescription.Tooltip);
/**
 * Configuration for text, and only text, input.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=126724%3A293625&t=F7FEEyRf4ee89URW-1">Market - Input</a>
 *
 * SOURCE TextInputDescription @ squareup/bbfrontend/common/component/component.proto at 89:1
 */
export const TextInputDescription = $root.lookupType('squareup.bbfrontend.common.component.TextInputDescription');
fixType(TextInputDescription, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TextInputDescription);
/**
 * SOURCE Formatter @ squareup/bbfrontend/common/component/component.proto at 90:3
 */
TextInputDescription.Formatter = $root.lookupEnum('squareup.bbfrontend.common.component.TextInputDescription.Formatter').values;
/**
 * Configuration for money, and only money, input.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=126724%3A293625&t=F7FEEyRf4ee89URW-1">Market - Input</a>
 *
 * SOURCE MoneyInputDescription @ squareup/bbfrontend/common/component/component.proto at 109:1
 */
export const MoneyInputDescription = $root.lookupType('squareup.bbfrontend.common.component.MoneyInputDescription');
fixType(MoneyInputDescription, {
  label: {
    notEmpty: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(MoneyInputDescription);
/**
 * Configuration for a banner element.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127056-293706&t=WyErUcd04HTzDkYR-4">Market - Banner</a>
 *
 * SOURCE BannerDescription @ squareup/bbfrontend/common/component/component.proto at 133:1
 */
export const BannerDescription = $root.lookupType('squareup.bbfrontend.common.component.BannerDescription');
fixType(BannerDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BannerDescription);
/**
 * SOURCE BannerVariant @ squareup/bbfrontend/common/component/component.proto at 138:3
 */
BannerDescription.BannerVariant = $root.lookupEnum('squareup.bbfrontend.common.component.BannerDescription.BannerVariant').values;
/**
 * Configuration for a pill element.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127056-293706&t=WyErUcd04HTzDkYR-4">Market - Pill</a>
 *
 * SOURCE PillDescription @ squareup/bbfrontend/common/component/component.proto at 155:1
 */
export const PillDescription = $root.lookupType('squareup.bbfrontend.common.component.PillDescription');
fixType(PillDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PillDescription);
/**
 * SOURCE PillVariant @ squareup/bbfrontend/common/component/component.proto at 161:3
 */
PillDescription.PillVariant = $root.lookupEnum('squareup.bbfrontend.common.component.PillDescription.PillVariant').values;
/**
 * SOURCE PillSize @ squareup/bbfrontend/common/component/component.proto at 176:3
 */
PillDescription.PillSize = $root.lookupEnum('squareup.bbfrontend.common.component.PillDescription.PillSize').values;
/**
 * A URL that the client is expected to open in a web browser.
 *
 * SOURCE WebURL @ squareup/bbfrontend/common/component/component.proto at 189:1
 */
export const WebURL = $root.lookupType('squareup.bbfrontend.common.component.WebURL');
fixType(WebURL, {
  urlString: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WebURL);
/**
 * A date input field.
 *
 * SOURCE DateInputDescription @ squareup/bbfrontend/common/component/component.proto at 199:1
 */
export const DateInputDescription = $root.lookupType('squareup.bbfrontend.common.component.DateInputDescription');
fixType(DateInputDescription, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DateInputDescription);
/**
 * Configuration for address input fields.
 *
 * SOURCE AddressInputDescription @ squareup/bbfrontend/common/component/component.proto at 207:1
 */
export const AddressInputDescription = $root.lookupType('squareup.bbfrontend.common.component.AddressInputDescription');
fixType(AddressInputDescription);
Builder.createAndAttachToType(AddressInputDescription);
/**
 * SOURCE ErrorFieldType @ squareup/bbfrontend/common/component/component.proto at 215:3
 */
AddressInputDescription.ErrorFieldType = $root.lookupEnum('squareup.bbfrontend.common.component.AddressInputDescription.ErrorFieldType').values;